/**
 * Standard Ethereum bloom filter size in bytes (256 bytes = 2048 bits)
 * @type {256}
 */
export const SIZE = 256;

/**
 * Number of bits in the bloom filter (2048)
 * @type {2048}
 */
export const BITS = 2048;

/**
 * Default number of hash functions for Ethereum bloom filters
 * @type {3}
 */
export const DEFAULT_HASH_COUNT = 3;
